
<template>
   <v-layout row wrap>
      <v-flex xs12 sm4>
         <v-toolbar color="brown lighten-2" dark>
            <v-toolbar-title>Relevés de suivi alimentaire</v-toolbar-title>
         </v-toolbar>
         <v-card>

            <v-list two-line subheader>
                <v-btn @click="addFractionningDialog" fab small color="yellow" top right absolute>
                    <v-icon>add</v-icon>
                </v-btn>

               <template v-for="(fractionning, index) in fractionnings">
                  <v-subheader :key="fractionning.id">
                     {{ fractionningDescription(fractionning) }}
                     <v-btn icon ripple @click.stop="editFractionningDialog(fractionning.date)">
                        <v-icon color="grey lighten-1">edit</v-icon>
                     </v-btn>
                  </v-subheader>
                  <v-divider></v-divider>

                  <template v-for="(meal, index) in surveyMeals[fractionning.date]">
                     <v-list-tile :key="fractionning.id + ',' + meal.id" avatar ripple
                           @click="selectMeal(meal.id)" v-bind:class="{ 'red': meal.id === selectedMealId, 'lighten-4': meal.id === selectedMealId }">
                        <v-list-tile-avatar>
                           <v-icon>restaurant</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                           <v-list-tile-title>{{ mealIndexName(meal) }}</v-list-tile-title>
                        </v-list-tile-content>
                     </v-list-tile>
                  </template>

               </template>
            </v-list>

            <v-card-text v-if="fractionnings.length === 0"  style="height: 80px;" class="Aligner">
               <v-icon>not_interested</v-icon>
            </v-card-text>

         </v-card>

      </v-flex>

      <v-flex class="xs12 sm5">
         <router-view name="mealElements"></router-view>
      </v-flex>

      <v-flex class="xs12 sm3">
         <router-view name="favorites" @addFavorite="addFavorite"></router-view>
      </v-flex>

      <fractionning-dialog v-if="fractionningDialog"
         :title='"Journée de relevé alimentaire"'
         :disableDate="disableFractionningDate"
         :value="editedFractionning"
         @input="setFractionning" @close="fractionningDialog = false"
      />

   </v-layout>
</template>


<script>
   import Vue from 'vue'
   import moment from 'moment'
   import _ from 'lodash'
   import fuzzy from '@/utilities/fuzzy.js'
   import config from '@/config'
   import { required } from 'vuelidate/lib/validators'
   import FractionningDialog from '@/components/meals/FractionningDialog.vue'

   export default {

      props: {
         userId: Number,
         baseRoute: String,
      },

      components: {
         FractionningDialog: FractionningDialog,
      },

      mounted() {
         this.fetchSurveyData()
      },

      data () {
         return {
            selectedMealId: null,
            fractionningDialog: false,
            editedFractionning: {},
            disableFractionningDate: true,
         }
      },

      computed: {
         fractionnings() {
            if (this.$store.state.meals.user2surveyFractionningList[this.userId]) {
               return this.$store.state.meals.user2surveyFractionningList[this.userId].map(id => this.$store.state.meals.fractionnings[id])
            } else {
               return []
            }
         },
         surveyMeals() {
            let date2meals = {}
            this.fractionnings.forEach(fractionning => {
               if (this.$store.state.meals.user2date2index2meal[this.userId] && this.$store.state.meals.user2date2index2meal[this.userId][fractionning.date]) {
                  let index2meal = this.$store.state.meals.user2date2index2meal[this.userId][fractionning.date]
                  let dateMeals = Object.values(index2meal).map(id => this.$store.state.meals.meals[id])
                  date2meals[fractionning.date] = dateMeals
               }
            })
            return date2meals
         },
         defaultMealIndexes() {
            return config.MEAL_TYPE_LIST.filter(index => config.MEAL_TYPES[index]['default'])
         },
         selectedMeal() {
            return this.$store.state.meals.meals[this.selectedMealId]
         },
      },
      
      methods: {
         async fetchSurveyData() {
            // fetch fractionnings of all days of survey
            let fractionnings = await this.$store.dispatch('meals/GET_SURVEY_FRACTIONNINGS', this.userId)
            // then fetch associated meals
            fractionnings.forEach(async fractionning => {
               this.$store.dispatch('meals/GET_USER_DAY_MEALS', { userId: this.userId, date: fractionning.date })
            })
         },

         addFractionningDialog() {
            let today = moment().format('YYYY-MM-DD')
            this.editedFractionning = {
               user: this.userId,
               date: today,
               mealPresenceArray: _.clone(this.defaultMealIndexes),
               surveyIndex: 0
            }
            this.disableFractionningDate = false
            this.fractionningDialog = true
         },
         editFractionningDialog(date) {
            let fractionningId = this.$store.state.meals.user2date2fractionning[this.userId][date]
            let fractionning = this.$store.state.meals.fractionnings[fractionningId]
            this.editedFractionning = _.cloneDeep(fractionning)
            this.disableFractionningDate = true
            this.fractionningDialog = true
         },
         
         setFractionning() {
            if (this.editedFractionning.id) {
               let previousFractionning = _.cloneDeep(this.$store.state.meals.fractionnings[this.editedFractionning.id])
               // update existing fractionning
               this.$store.dispatch('meals/PUT_FRACTIONNING', this.editedFractionning)
               // compare `editedFractionning` and `previousFractionning` and add/delete meals accordingly
               this.editedFractionning.mealPresenceArray.forEach(index => {
                  if (previousFractionning.mealPresenceArray.indexOf(index) === -1) {
                     // add new meal
                     this.$store.dispatch('meals/POST_USER_MEAL', { user: this.userId, date: this.editedFractionning.date, index: index, extra: {} })
                  }
               })
               previousFractionning.mealPresenceArray.forEach(index => {
                  if (this.editedFractionning.mealPresenceArray.indexOf(index) === -1) {
                     // delete existing meal
                     let mealId = this.$store.state.meals.user2date2index2meal[this.userId][this.editedFractionning.date][index]
                     this.$store.dispatch('meals/DELETE_USER_MEAL', this.$store.state.meals.meals[mealId])
                  }
               })
            } else {
               // add new fractionning
               // check whether a fractionning for this date already exist
               if (this.$store.state.meals.user2date2fractionning[this.userId] && this.$store.state.meals.user2date2fractionning[this.userId][this.editedFractionning.date]) {
                  // a fractionning for this date already exist
                  this.$store.commit('SNACKBAR', { timeout: 3500, text: "Des repas existent déjà pour cette journée", color: 'red' })
               } else {
                  // create new fractionning
                  this.$store.dispatch('meals/POST_FRACTIONNING', this.editedFractionning)
                  // create associated empty meals
                  this.editedFractionning.mealPresenceArray.forEach(index => {
                     this.$store.dispatch('meals/POST_USER_MEAL', { user: this.userId, date: this.editedFractionning.date, index: index, extra: {} })
                  })
               }
            }
         },

         fractionningDescription(fractionning) {
            let surveyDescription = config.MEAL_SURVEYS[fractionning.surveyIndex]
            if (surveyDescription) {
               let dateDescription = moment(fractionning.date).format("DD/MM/YYYY, dddd")
               return `${surveyDescription.name} - ${dateDescription}`
            } else {
               return ''
            }
         },

         mealIndexName (meal) {
            return config.MEAL_TYPES[meal.index] ? config.MEAL_TYPES[meal.index].name : ''
         },

         async selectMeal (mealId) {
            this.selectedMealId = mealId
            let meal = await this.$store.dispatch('meals/GET_MEAL', mealId)
            // fetch meal elements
            this.$store.dispatch('meals/GET_MEAL_ELEMENTS', mealId)
            // fetch favorites
            this.$store.dispatch('meals/GET_FAVORITES', { userId: this.userId, index: meal.index })
            // change route : UserMealElements will have all necessary information (mealElements)
            this.$router.push(`${this.baseRoute}${meal.date}/${meal.index}`)
         },

         emitMealsUpdatedEvent () {
            // send event to Coaching component
            this.$emit('userMealsUpdated', this.userId)
         },

         async addFavorite(favorite) {
            // create and add meal element from favorite
            let portionWeight = fuzzy.parse(favorite.portion_weight)
            let weight = fuzzy.multiplyByScalar(portionWeight, parseFloat(favorite.nbportion))
            let mealElement = { meal: this.selectedMealId, food: favorite.food, weight: fuzzy.format(weight), portion: favorite.portion, nbportion: favorite.nbportion }
            this.$store.dispatch('meals/POST_MEAL_ELEMENT', mealElement)
            // increment favorite count
            let favoriteCopy = Object.assign({}, favorite)
            favoriteCopy.count += 1
            this.$store.dispatch('meals/PUT_FAVORITE', favoriteCopy)
            // fetch favorite's associated foodPortion
            let foodPortion = await this.$store.dispatch('meals/GET_FOODPORTION', favorite.portion)
            // then fetch associated food and food's nutdata
            this.$store.dispatch('meals/GET_FOOD', foodPortion.food)
            this.$store.dispatch('meals/GET_FOOD_NUTDATA', foodPortion.food)
         },
      },

   };
</script>



// WEBPACK FOOTER //
// UserMealSurveys.vue?b23a83cc